import moment from 'moment';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData, refreshApBasicData } from './helpers/basicHelper';
import { addDNoneClass, btnLoading, byId, capitalizeFirstLetter, convertToInt, convertToTwoDecimalInt, unixTimeStampInSeconds } from './helpers/utility';






authHelper.validate();
hydrateApBasicData();


const planSelectInput = byId('planSelectInput');
const durationSelectInput = byId('durationSelectInput');
const basePriceSpan = byId('basePriceSpan');
const finalPriceSpan = byId('finalPriceSpan');
const monthsSpan = byId('monthsSpan');
const totalSpan = byId('totalSpan');
const discountSpan = byId('discountSpan');
const discountPercentSpan = byId('discountPercentSpan');
const finalAmountSpan = byId('finalAmountSpan');
const payNowBtn = byId('payNowBtn');
const purchaseInitBtn = byId('purchaseInitBtn');
const purchaseDiv = byId('purchaseDiv');
const activePlanDiv = byId('activePlanDiv');
const baseMultipleSpan = byId('baseMultipleSpan');
const cancelInitBtn = byId('cancelInitBtn');
const cancelNowBtn = byId('cancelNowBtn');

const cancelDiv = byId('cancelDiv');

const activePlanPurchasePriceSpan = byId('activePlanPurchasePriceSpan');
const activePlanTotalDaysSpan = byId('activePlanTotalDaysSpan');
const activePlanPerDayPrice = byId('activePlanPerDayPrice');
const activePlanUsageDays = byId('activePlanUsageDays');
const activePlanUsageAmount = byId('activePlanUsageAmount');
const activePlanRefundAmount = byId('activePlanRefundAmount');

let allUsersCount;

let activePlanPurchasePrice;
let activePlanStartingTimeStamp;
let activePlanEndingTimeStamp;



const getActivePlanDetails = () => {
    addDNoneClass(purchaseInitBtn, true);
    callTheApServerGet(`/basic/getActivePlanDetails`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;



        if (res.status === 'success') {
            console.log(res);

            const { _count, owners_plan_details } = res.activePlanData;
            let { activePlan, validTill, purchasePrice, startedAt, } = owners_plan_details;
            allUsersCount = _count.all_users;
            activePlanPurchasePrice = convertToInt(purchasePrice);
            activePlanStartingTimeStamp = startedAt;
            activePlanEndingTimeStamp = validTill;
            activePlan = activePlan.toLowerCase();
            byId('activePlanH3').innerHTML = `Active Plan : ${capitalizeFirstLetter(activePlan)}`;

            let validTillText = moment(validTill * 1000).format('DD/MM/YYYY');
            if (unixTimeStampInSeconds() > validTill) {
                validTillText = 'Expired';
                addDNoneClass(purchaseInitBtn, false);
            }
            if (activePlan === 'free') {
                validTillText = 'Lifetime';
                addDNoneClass(purchaseInitBtn, false);
            } else {
                if (unixTimeStampInSeconds() < validTill) {
                    addDNoneClass(cancelInitBtn, false);
                }
            }


            byId('activePlanValidityH5').innerHTML = `Validity : ${validTillText}`;




        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};
getActivePlanDetails();
// calculate 
const calculateFinalPrice = () => {

    let basePrice, discountPercent;
    let baseMultiple = 1;

    baseMultiple = Math.trunc(allUsersCount / 5000) + 1;
    const months = convertToInt(durationSelectInput.value);
  if (planSelectInput.value === 'premium') {
        basePrice = 200;
    }
   const  finalPrice = basePrice * baseMultiple;
    if (months === 1) {
        discountPercent = 0;
    } else if (months === 3) {
        discountPercent = 10;
    } else if (months === 6) {
        discountPercent = 20;
    } else if (months === 12) {
        discountPercent = 30;
    }
    const totalAmount = finalPrice * months;

    const discountAmount = (discountPercent / 100) * totalAmount;

    const finalAmount = totalAmount - discountAmount;

    // setting values in span
    baseMultipleSpan.innerHTML = baseMultiple;
    basePriceSpan.innerHTML = basePrice;
    finalPriceSpan.innerHTML = finalPrice;
    monthsSpan.innerHTML = months;

    totalSpan.innerHTML = totalAmount;
    discountSpan.innerHTML = discountAmount;
    discountPercentSpan.innerHTML = discountPercent;
    finalAmountSpan.innerHTML = finalAmount;

};
window.calculateFinalPrice = calculateFinalPrice;


const purchasePlanInit = (state) => {
    if (state === true) {
        calculateFinalPrice();
        addDNoneClass(activePlanDiv, true);
        addDNoneClass(purchaseDiv, false);
    } else {
        addDNoneClass(activePlanDiv, false);
        addDNoneClass(purchaseDiv, true);
    }
};
window.purchasePlanInit = purchasePlanInit;

const purchasePlanSubmit = async () => {


    try {
        btnLoading(payNowBtn, '', true);
        const data = {

            months: convertToInt(durationSelectInput.value),
            plan: planSelectInput.value


        };

        const response = await callTheApServerPost(`/basic/purchasePlan`, { data });
        axiosResponseHandler(response);
        const res = response.data;

        btnLoading(payNowBtn, '', false);

        if (res.status === 'success') {
            console.log(res);

          await  Swal.fire({
                icon: 'success',
                title: 'Plan Purchase Success',
                text: `Congratulation your ${planSelectInput.value} plan  is get activated for ${convertToInt(durationSelectInput.value)} months`,

            });

            getActivePlanDetails();
            purchasePlanInit(false);
            // update plan in token 
            authHelper.validate(true);
            // update plan in local storage 
          await  refreshApBasicData();

        }

    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }


};

// window.purchasePlanSubmit = purchasePlanSubmit;

payNowBtn.addEventListener('click', purchasePlanSubmit);

const calculateRefundAmount = () => {
    activePlanPurchasePriceSpan.innerHTML = activePlanPurchasePrice;
    const diffTimeStampTotal = activePlanEndingTimeStamp - activePlanStartingTimeStamp;

    let diffDaysTotal = diffTimeStampTotal / (60 * 60 * 24);
    diffDaysTotal = Math.trunc(diffDaysTotal);

    const diffTimeStampTillNow = unixTimeStampInSeconds() - activePlanStartingTimeStamp;

    let diffDaysTillNow = diffTimeStampTillNow / (60 * 60 * 24);
    diffDaysTillNow = Math.trunc(diffDaysTillNow);


    activePlanTotalDaysSpan.innerHTML = diffDaysTotal;
    let perDayPrice = activePlanPurchasePrice / diffDaysTotal;
    perDayPrice = convertToTwoDecimalInt(perDayPrice);
    activePlanPerDayPrice.innerHTML = perDayPrice;
    activePlanUsageDays.innerHTML = diffDaysTillNow;
    let usageAmount = perDayPrice * diffDaysTillNow;
    usageAmount = convertToTwoDecimalInt(usageAmount);
    activePlanUsageAmount.innerHTML = usageAmount;

    let refundAmount = activePlanPurchasePrice - usageAmount;


    if (refundAmount < 0) {
        refundAmount = 0;
    }
    activePlanRefundAmount.innerHTML = refundAmount;
};

const cancelPlanInit = (state) => {
    if (state === true) {
        calculateRefundAmount();
        addDNoneClass(activePlanDiv, true);
        addDNoneClass(cancelDiv, false);
    } else {
        addDNoneClass(activePlanDiv, false);
        addDNoneClass(cancelDiv, true);
    }
};
window.cancelPlanInit = cancelPlanInit;

/* disabling cancel feature  */
const cancelPlanSubmit = async () => {
    try {
        btnLoading(payNowBtn, '', true);
        const response = await callTheApServerGet(`/basic/cancelPlan`);
        axiosResponseHandler(response);
        const res = response.data;

        btnLoading(payNowBtn, '', false);

        if (res.status === 'success') {
            console.log(res);

            await Swal.fire({
                icon: 'success',
                title: 'Plan Cancelled',
                text: `₹ ${res.refundAmount} Refunded to Your Bonus Wallet `,

            });

            getActivePlanDetails();
            cancelPlanInit(false);
            // update plan in token 
            authHelper.validate(true);
            // update plan in local storage 
            await refreshApBasicData();

        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }



};

// window.purchasePlanSubmit = purchasePlanSubmit;

// cancelNowBtn.addEventListener('click', cancelPlanSubmit);